/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { llmExtractUpdateSchema } from "../../funcs/llmExtractUpdateSchema.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.UpdateExtractSchemaRequest$inboundSchema,
};

export const tool$llmExtractUpdateSchema: ToolDefinition<typeof args> = {
  name: "llm-extract-update-schema",
  description: `Update extraction schema by ID

Update an existing extraction schema and its metadata.`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await llmExtractUpdateSchema(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
